import {useOnMountEffect} from "@khanacademy/wonder-blocks-core";
import {updateFlagsCookieFromURL} from "@khan/data-cookies";
import {useLocation} from "@khan/urls";

/**
 * Parse the query string to set or clear feature flag cookies.
 *
 * This hook checks the URL query parameters for feature flag settings
 * and updates the cookies accordingly when the component mounts. If there
 * are no flag_on or flag_off query parameters at all, the cookie is left as-is.
 * To clear the cookie entirely, it must be done explicitly with
 * the `eraseCookie` function.
 */
export const useFlagsQueryParamToCookie = () => {
    const {search} = useLocation();

    useOnMountEffect(() => {
        updateFlagsCookieFromURL(new URLSearchParams(search));
    });
};
